<!-- 关联指数 -->
<template>
  <div v-if="!$isEmpty(indexInfo) && !$isEmpty(indexInfo.indexName)" class="index-box row">
    <div class="name">{{`关联指数｜${indexInfo.indexName}`}}</div>
    <div class="more row" @click="$goFundApp">
      <div>详情</div>
      <img :src="arrow" class="arrow"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'related-index',

  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      arrow: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  computed: {
    indexInfo() {
      return this.detailInfo?.indexInfo || {};
    },
  },
};
</script>

<style lang="less" scoped>
.index-box {
  width: 100%;
  border-radius: 12px;
  box-sizing: border-box;
  background-color: #ffffff;
  padding: 24px;
  margin-bottom: 24px;
  justify-content: space-between;
}
.row {
  display: flex;
  align-items: center;
  flex-direction: row;
}
.name {
  font-size: 32px;
  color: #000000;
  flex: 1;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.more {
  justify-content: right;
  font-size: 28px;
  color: #666666;
}
.arrow {
  width: 32px;
  height: 32px;
  margin-left: 8px;
}
</style>
